// test719
(719 && 0);
